import React, { useEffect } from "react";
import axios from "axios";
import styled from "styled-components";

import { generatePageTitle } from "utils/general.utils";

function reportWindowSize() {
  const vw = Math.max(
    document.documentElement.clientWidth || 0,
    window.innerWidth || 0
  );
  const vh = Math.max(
    document.documentElement.clientHeight || 0,
    window.innerHeight || 0
  );

  // Update iframe width and height based on the window size
  document
    .getElementById("MedSKU")
    ?.setAttribute("style", `width: ${vw - 150}px; height: ${vh}px;`);
}

window.addEventListener("resize", reportWindowSize);

const ImportMedSKUDashboard: React.FC = () => {
  const idToken = axios.defaults.headers.common["Authorization"].split(
    "Bearer "
  )[1];

  useEffect(() => {
    document.title = generatePageTitle("Import MedSKU Dashboard");
  });

  reportWindowSize();

  if (process.env.NODE_ENV === "production") {
    return (
      <Iframe
        id="MedSKU"
        title="MedSKU"
        frameBorder="0"
        scrolling="yes"
        src={`/medsku/importdata?idToken=${idToken}`}
      ></Iframe>
    );
  } else {
    return (
      <Iframe
        id="MedSKU"
        title="MedSKU"
        frameBorder="0"
        scrolling="yes"
        src={`http://${process.env.REACT_APP_LOCAL_SERVER ?? 'localhost'}:5010/medsku/importdata?idToken=${idToken}`}
      ></Iframe>
    );
  }
};

const Iframe = styled.iframe`
  height: 100vh;
  width: 92vw;
`;

export default ImportMedSKUDashboard;
